module.exports = __webpack_public_path__ + "img/frame06_current.9ad218ac.png";